// Copyright (c) 2017 Comsearch, Inc., All rights reserved

import React from 'react'
import { func, string } from 'prop-types'
import { useDispatch } from 'react-redux'
import { reduxForm, Field } from 'redux-form'
import { asrLookupValidator } from 'validators/lookups'
import { FormWrapper } from './styles'
import clearASRValues from './clearASRValues'
import { roundToFixedOnBlur } from 'validators/common'

import {
  handleOnBlurCoordinateField,
  handleOnPasteCoordinateField,
} from 'helpers/coordsConversion'

import {
  SubmitErrors,
  UpdatedLabeledInput,
} from 'components/Form'

const Form = ({ error, form, handleSubmit }) => {
  const dispatch = useDispatch()
  return (
    <FormWrapper
      className={'heading-font'}
      id={'asr-lookup'}>
      <SubmitErrors
        error={error}
        idRoot={form}
        sourceForm={form} />
      <Field
        autoFocus={true}
        className={'asr-number'}
        component={UpdatedLabeledInput}
        id={'asr-lookup-asr'}
        label={'ASR Number'}
        name={'asr'}
        placeholder={'ASR Number'}/>
      <Field
        className={'asr-latitude'}
        component={UpdatedLabeledInput}
        id={'asr-lookup-latitude'}
        label={'Latitude'}
        name={'latitude'}
        onBlurCustom={handleOnBlurCoordinateField}
        onPasteCustom={handleOnPasteCoordinateField}
        placeholder={'Latitude'} />
      <Field
        className={'asr-longitude'}
        component={UpdatedLabeledInput}
        id={'asr-lookup-longitude'}
        label={'Longitude'}
        name={'longitude'}
        onBlurCustom={handleOnBlurCoordinateField}
        onPasteCustom={handleOnPasteCoordinateField}
        placeholder={'Longitude'} />
      <Field
        className={'search-radius'}
        component={UpdatedLabeledInput}
        id={'asr-lookup-radius'}
        label={'Search Radius (seconds)'}
        name={'radius'}
        onBlurCustom={roundToFixedOnBlur}
        placeholder={'1 (second)'} />
      <button
        className={'asr-lookup-search btn search-button'}
        id={'asr-lookup-submit'}
        onClick={handleSubmit}
        type={'submit'} />
      <button
        type={'button'}
        className={'fa fa-eraser pointer clear-button'}
        id={'clearValues'}
        onClick={() => dispatch(clearASRValues(form))} />
    </FormWrapper>
  )
}

Form.propTypes = {
  error: string,
  form: string.isRequired,
  handleSubmit: func.isRequired,
}

const { validate } = asrLookupValidator

export default reduxForm({
  validate,
})(Form)
